<script>
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
    import ConnectionIssuesModal from "../modal/ConnectionIssuesModal.svelte";
    import Heartbeat from "./Heartbeat.svelte";
</script>

<svelte:options accessors />

<Header />
<main id="brak-content">
    <slot />
</main>
<Footer />

<Heartbeat />
<ConnectionIssuesModal/>

